
import { mapState } from "vuex";
import noDataLabel from "../common/no-data-label.vue";
export default {
  components: { noDataLabel },
  props: {
    selectedItem: {
      default: {}
    }
  },
  data() {
    return {
      series: [
        {
          name: "",
          data: []
        },
        {
          name: "",
          data: []
        }
      ],
      chartOptions: {
        colors: ["#008FFB", "#C8C8C8"],
        annotations: {
          xaxis: [
            {
              x: new Date().getTime(),
              // strokeDashArray: 5,
              borderColor: "#999",
              yAxisIndex: 0,
              label: {
                show: true,
                text: "Now",
                position: "top",
                orientation: "horizontal",
                style: {
                  color: "#fff",
                  background: "#28D484",
                  fontSize: "13px"
                }
              }
            }
          ]
        },
        chart: {
          height: 350,
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false
          }
          // type: ["area", "line"]
        },
        dataLabels: {
          enabled: false
        },
        // fill: {
        //   type: ["gradient", "image"]
        // },
        stroke: {
          curve: "smooth",
          dashArray: [0, 5],
          width: [1.5, 1.5]
        },
        xaxis: {
          type: "datetime",
          labels: {
            datetimeUTC: false,
            datetimeFormatter: {
              year: "yyyy",
              month: "MMM 'yy",
              day: "dd MMM",
              hour: "hh:mm TT"
            }
          },
          categories: []
        },
        yaxis: {
          labels: {
            formatter: (val) => {
              return val;
            }
          }
        },
        tooltip: {
          x: {
            show: false,
            format: "dd/MM/yy HH:mm",
            format: "dd/MM/yy hh:mm TT"
          }
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
          onItemClick: {
            toggleDataSeries: false
          }
        }
      }
    };
  },
  computed: {
    ...mapState("report", ["businessGraphData", "businessGraphDataLoading"])
  },
  beforeMount() {
    if (this.businessGraphData?.current_period) {
      this.series = [];
      this.series.push({
        name: "Current",
        data: this.businessGraphData.current_period
      });
      this.series.push({
        name: "Previous",
        data: this.businessGraphData.previous_period
      });
      this.chartOptions.yaxis.labels.formatter = (val) => {
        if (this.selectedItem.unit === "currency") {
          return `₹ ${Math.round(val * 100) / 100}`;
        }
        return `${this.selectedItem.unit} ${Math.round(val * 100) / 100}`;
      };
      this.chartOptions.xaxis.categories = this.businessGraphData.timestamps;
      const highestValue = Math.max(
        ...this.businessGraphData.current_period,
        ...this.businessGraphData.previous_period
      );
      if (highestValue <= 5) {
        this.chartOptions.yaxis.stepSize = 1;
      }
    }
  }
};
